export class Timer {
  private timerId: number | null
  private start: number
  private remaining: number

  constructor(
    private callback: () => void,
    delay: number,
  ) {
    this.timerId = null
    this.start = 0
    this.remaining = delay
    this.resume()
  }

  pause() {
    window.clearTimeout(this.timerId)
    this.timerId = null
    this.remaining -= Date.now() - this.start
  }

  resume() {
    if (this.timerId) {
      return
    }

    this.start = Date.now()
    this.timerId = window.setTimeout(this.callback, this.remaining)
  }
}
